export const BASE_URL = '';
export const SITES_URL = '/api/sites';
export const USERS_URL = '/api/users';
export const PROBLEMS_URL = '/api/problems';
export const UPLOAD_URL = '/api/upload';
export const DEVICES_URL = '/api/devices';
export const NOTES_URL = '/api/notes';
export const TASKS_URL = '/api/tasks';
export const ZABBIX_URL = '/api/zabbix';
export const REPS_URL = '/api/reps';
export const DATTORMM_URL = '/api/dattormm';
export const PROOFPOINT_URL = '/api/proofpoint';
export const UNITRENDS_URL = '/api/unitrends';
export const METRICS_URL = '/api/metrics';
export const ONBOARDING_URL = '/api/onboarding';